module.exports = __webpack_public_path__ + "static/dl2-stay-human_logo-0fe4c872f69a3e5945fdb9c770653b79.svg";